import {
  TbAirConditioning,
  TbAntenna,
  TbBattery,
  TbBell,
  TbBluetooth,
  TbBolt,
  TbBoxMultiple,
  TbBuildingFactory,
  TbBulb,
  TbBulldozer,
  TbCamera,
  TbChargingPile,
  TbChartBar,
  TbCircuitAmmeter,
  TbCircuitBattery,
  TbCircuitCapacitor,
  TbCircuitCell,
  TbCircuitChangeover,
  TbCircuitDiode,
  TbCircuitGround,
  TbCircuitInductor,
  TbCircuitMotor,
  TbCircuitPushbutton,
  TbCircuitResistor,
  TbCircuitSwitchClosed,
  TbCircuitSwitchOpen,
  TbClockCog,
  TbCloud,
  TbCrane,
  TbCpu,
  TbCylinder,
  TbDeviceCctv,
  TbDeviceDesktop,
  TbDeviceMobile,
  TbDroplet,
  TbElevator,
  TbEngine,
  TbFilter,
  TbFlame,
  TbForklift,
  TbGasStation,
  TbGauge,
  TbHammer,
  TbHomeCog,
  TbLayoutDashboard,
  TbLink,
  TbLock,
  TbMagnet,
  TbMicroscope,
  TbMotorbike,
  TbNetwork,
  TbOutlet,
  TbPackage,
  TbPhotoSensor,
  TbPlug,
  TbPlugConnected,
  TbPower,
  TbPropeller,
  TbRadio,
  TbRobot,
  TbRouter,
  TbSatellite,
  TbScale,
  TbServer,
  TbSettings,
  TbSettingsAutomation,
  TbShieldBolt,
  TbSolarPanel,
  TbTemperature,
  TbTestPipe,
  TbTool,
  TbTransform,
  TbTruck,
  TbWashMachine,
  TbWifi,
  TbWind,
  TbWindmill,
  TbWorld,
  TbZoomCode,
} from "react-icons/tb";
import { GiDustCloud, GiRoundSilo, GiValve } from "react-icons/gi";

export const HOME_CATEGORY_ICON_REGISTRY = {
  "ri-tb-bulb": TbBulb,
  "ri-tb-propeller": TbPropeller,
  "ri-tb-cpu": TbCpu,
  "ri-tb-circuit-switch-closed": TbCircuitSwitchClosed,
  "ri-tb-bolt": TbBolt,
  "ri-tb-magnet": TbMagnet,
  "ri-gi-valve": GiValve,
  "ri-tb-settings-automation": TbSettingsAutomation,
  "ri-tb-link": TbLink,
  "ri-tb-circuit-switch-open": TbCircuitSwitchOpen,
  "ri-tb-temperature": TbTemperature,
  "ri-tb-circuit-changeover": TbCircuitChangeover,
  "ri-tb-clock-cog": TbClockCog,
  "ri-tb-circuit-pushbutton": TbCircuitPushbutton,
  "ri-tb-power": TbPower,
  "ri-tb-shield-bolt": TbShieldBolt,
  "ri-tb-scale": TbScale,
  "ri-tb-cylinder": TbCylinder,
  "ri-tb-filter": TbFilter,
  "ri-tb-tool": TbTool,
  "ri-tb-circuit-ammeter": TbCircuitAmmeter,
  "ri-tb-plug-connected": TbPlugConnected,
  "ri-gi-round-silo": GiRoundSilo,
  "ri-tb-wind": TbWind,
  "ri-tb-box-multiple": TbBoxMultiple,
  "ri-gi-dust-cloud": GiDustCloud,
  "ri-tb-transform": TbTransform,
  "ri-tb-circuit-cell": TbCircuitCell,
  "ri-tb-gauge": TbGauge,
  "ri-tb-photo-sensor": TbPhotoSensor,
  "ri-tb-air-conditioning": TbAirConditioning,
  "ri-tb-antenna": TbAntenna,
  "ri-tb-battery": TbBattery,
  "ri-tb-bell": TbBell,
  "ri-tb-bluetooth": TbBluetooth,
  "ri-tb-building-factory": TbBuildingFactory,
  "ri-tb-bulldozer": TbBulldozer,
  "ri-tb-camera": TbCamera,
  "ri-tb-charging-pile": TbChargingPile,
  "ri-tb-chart-bar": TbChartBar,
  "ri-tb-circuit-battery": TbCircuitBattery,
  "ri-tb-circuit-capacitor": TbCircuitCapacitor,
  "ri-tb-circuit-diode": TbCircuitDiode,
  "ri-tb-circuit-ground": TbCircuitGround,
  "ri-tb-circuit-inductor": TbCircuitInductor,
  "ri-tb-circuit-motor": TbCircuitMotor,
  "ri-tb-circuit-resistor": TbCircuitResistor,
  "ri-tb-cloud": TbCloud,
  "ri-tb-crane": TbCrane,
  "ri-tb-device-cctv": TbDeviceCctv,
  "ri-tb-device-desktop": TbDeviceDesktop,
  "ri-tb-device-mobile": TbDeviceMobile,
  "ri-tb-droplet": TbDroplet,
  "ri-tb-elevator": TbElevator,
  "ri-tb-engine": TbEngine,
  "ri-tb-flame": TbFlame,
  "ri-tb-forklift": TbForklift,
  "ri-tb-gas-station": TbGasStation,
  "ri-tb-hammer": TbHammer,
  "ri-tb-home-cog": TbHomeCog,
  "ri-tb-layout-dashboard": TbLayoutDashboard,
  "ri-tb-lock": TbLock,
  "ri-tb-microscope": TbMicroscope,
  "ri-tb-motorbike": TbMotorbike,
  "ri-tb-network": TbNetwork,
  "ri-tb-outlet": TbOutlet,
  "ri-tb-package": TbPackage,
  "ri-tb-plug": TbPlug,
  "ri-tb-radio": TbRadio,
  "ri-tb-robot": TbRobot,
  "ri-tb-router": TbRouter,
  "ri-tb-satellite": TbSatellite,
  "ri-tb-server": TbServer,
  "ri-tb-settings": TbSettings,
  "ri-tb-solar-panel": TbSolarPanel,
  "ri-tb-test-pipe": TbTestPipe,
  "ri-tb-truck": TbTruck,
  "ri-tb-wash-machine": TbWashMachine,
  "ri-tb-wifi": TbWifi,
  "ri-tb-windmill": TbWindmill,
  "ri-tb-world": TbWorld,
  "ri-tb-zoom-code": TbZoomCode,
};

export const HOME_CATEGORY_FALLBACK_ICON = TbBoxMultiple;
